/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Checkbox } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { Dropdown } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  MinDate,
  MaxDate,
  dateFormatForDatePicker,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';

import {
  maintainContractActions,
  getDefaultRpcData,
  getWriteOffDateContract,
  getUndoWriteOffDateContract,
  handleErrorMessages,
  dispatchWriteOffDate,
  dispatchUndoWriteOffDate,
  getCommonDropdownList,
} from '../store/actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { WriteOffPopUp, UndoWriteOffPopUp } from './CreateContractModal';
import CommonModal from './CommonModal';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

import {
  validDate,
  checkQuarterValidation,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

const Detail = () => {
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const dispatch = useDispatch();
  const [writeOffDialog, setWriteOffDialog] = React.useState(false);
  const [undoWriteOffDialog, setUndoWriteOffDialog] = React.useState(false);
  const [sendCommDialog, setSendCommDialog] = React.useState(false);
  const [keyValue, setKeyValue] = React.useState([]);
  const [showViewHistory, setShowViewHistory] = React.useState(false);
  const [commonDropdownList, setCommonDropdownList] = useState({});
  // const logInUserID = localStorage.getItem('logInUser');
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(
      process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
      kcRoles
    )
  );
  const hasRole = (role) =>
    kcRoles?.userPrivileges?.some((r) => r === role) || false;

  // Normal User may edit Detail tab fields; admin-only actions stay gated by isEnablebyRole
  const isTabEditable = isEnablebyRole || hasRole('Normal User');
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const getDisputeSpecialists = useSelector(
    (state) => state?.sharedState?.ContractReducer?.getDisputeSpecialists
  );
  const getAllContractData = useSelector(
    (state) => state.sharedState.ContractReducer.getAllContractData
  );
  const getRpcData = useSelector(
    (state) => state.sharedState.ContractReducer.getDefaultRpcData
  );
  const getLetterSender = useSelector(
    (state) => state?.sharedState?.ContractReducer?.getLetterSender
  );
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const detailTab = useSelector(
    (state) =>
      state?.sharedState?.ContractReducer?.maintainContractState?.detailTab
  );
  const searchContractState = useSelector(
    (state) => state.sharedState.ContractReducer.searchContractState
  );
  const getWriteOffDate = useSelector(
    (state) => state.sharedState.ContractReducer.getWriteOffDate
  );
  const getUndoWriteOffDate = useSelector(
    (state) => state.sharedState.ContractReducer.getUndoWriteOffDate
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  // Setting the data on load of the page
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: ['DETAIL_LEVEL_ON_INVOICE_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
    if (
      searchContractState.contractType === 'onSelect' &&
      detailTab.useDefRpcInd === true
    )
      dispatch(
        getDefaultRpcData({
          mfgId: null,
          rebateProgramCd:
            searchContractState.contractType === 'onSelect'
              ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                  ?.rebateProgramCd
              : searchContractState.createRebateProgramCode,
        })
      );
    if (kcRoles?.userPrivileges.length > 0) {
      setIsEnablebyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_MAINTAIN_CHECK_DISABLE_ROLE,
          kcRoles
        )
      );
    }
  }, []);
  // On change of the field in detail tabs
  const onChangeDetailsField = (e, name) => {
    const data = {
      ...maintainContractState,
      showSaveButton: 'Yes',
      detailTab: {
        ...detailTab,
        [name]: e.target.value,
      },
    };
    dispatch(maintainContractActions(data));
  };
  // check validation for filed Level
  const handleOnBlurEventOnFields = (value, name) => {
    let localErr = errorMessagesFromRedux || [];
    if (value !== '') {
      if (checkQuarterValidation(value)) {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        dispatch(
          maintainContractActions({
            ...maintainContractState,
            detailTab: {
              ...detailTab,
              [name]: value?.toUpperCase(),
            },
          })
        );
      } else {
        localErr = localErr?.filter((item) => item.fieldName !== name);
        localErr.push({
          fieldName: name,
          errorType: 'invalidQuarterFormat',
          tabName: 'DetailTab',
          message: constantMessageData.VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr?.filter((item) => item.fieldName !== name);
    }
    dispatch(handleErrorMessages([...new Set(localErr)]));
  };
  // On click on the Actions
  const handleAction = () => {
    setWriteOffDialog(true);
    dispatch(dispatchWriteOffDate(''));
  };
  // handing view History popup
  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      CONTRACT_SEQ_NUM:
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          ?.contractSeqNum,
    });
  };
  // On change of the Date field
  const onChangeDateField = (d, name) => {
    if (d != 'Invalid Date') {
      dispatch(
        maintainContractActions({
          ...maintainContractState,
          detailTab: {
            ...detailTab,
            [name]: d,
            errorInvalidWirteOffDatePop: false,
          },
        })
      );
    }
  };
  // call on Blur event &OnChange even As of date filed level
  const handleOnBlurDateEvent = (d, name) => {
    let localErr = errorMessagesFromRedux || [];
    if (d !== 'Invalid Date') {
      let value = null;
      if (d.target.value && d.target.value.length > 5) {
        const data = d.target.value.split('/');
        if (data[2].split('_').length === 3) {
          value = moment(d.target.value, 'MM/DD/YY').format('MM/DD/YYYY');
        } else {
          // eslint-disable-next-line prefer-destructuring
          value = d.target.value;
        }
      }
      let showError = false;
      if (value && validDate(new Date(value)) === false) {
        showError = true;
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== name && item.errorType !== 'compareDateGreater'
        );
        localErr.push({
          fieldName: name,
          errorType: 'InvalidDate',
          tabName: 'DetailTab',
          message: constantMessageData.DATE_INVALID_FORMAT_ERROR,
        });
        dispatch(
          maintainContractActions({
            ...maintainContractState,
            detailTab: {
              ...detailTab,
              [name]: value,
            },
          })
        );
      } else if (
        value &&
        compareTwoDatesGreaterThanOrEqual(value, moment(MinDate))
      ) {
        showError = true;
        localErr = localErr?.filter(
          (item) =>
            item.fieldName !== name &&
            item.errorType !== 'InvalidDate' &&
            item.errorType !== 'compareDateGreater'
        );
        localErr.push({
          fieldName: name,
          errorType: 'compareDateGreater',
          tabName: 'DetailTab',
          message: constantMessageData.MINIMUM_WRITE_DATE_ERROR_FOR_CONTRACT,
        });
        dispatch(
          maintainContractActions({
            ...maintainContractState,
            detailTab: {
              ...detailTab,
              [name]: value,
            },
          })
        );
      }
      if (!showError) {
        localErr = localErr?.filter((item) => {
          return item.fieldName !== name;
        });
        dispatch(
          maintainContractActions({
            ...maintainContractState,
            detailTab: {
              ...detailTab,
              [name]: value,
            },
          })
        );
      }
      dispatch(handleErrorMessages([...new Set(localErr)]));
    }
  };
  // Validating the date field on blur
  const validateDateFormatOnBlur = (event, name) => {
    const errorMessages = [];
    let errorDate = false;
    const regex = new RegExp(/^[0-9/]+$/);
    const invoiceDate = event.target.value;
    const sptDate =
      invoiceDate && invoiceDate.includes('_')
        ? invoiceDate.split('_')
        : invoiceDate;
    const splitDate =
      sptDate && sptDate.length > 0 && sptDate[0].includes('/')
        ? sptDate[0].split('/')
        : sptDate;
    if (sptDate[0] && !regex.test(sptDate[0])) {
      errorDate = true;
    }
    if (event.target.value !== '' && !validDate(new Date(event.target.value))) {
      errorDate = true;
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2].length == 1 || splitDate[0] > 12)
    ) {
      errorDate = true;
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2] == 0 || splitDate[1] == 0 || splitDate[0] == 0)
    ) {
      errorDate = true;
    }
    if (
      splitDate.length == 3 &&
      (splitDate[2].length == 3 || splitDate[2].length == 1)
    ) {
      errorDate = true;
    }
    if (
      splitDate.length == 2 &&
      (splitDate[1].length == 1 || splitDate[0] > 12)
    ) {
      errorDate = true;
    }
    if (splitDate.length == 2 && (splitDate[1] == 0 || splitDate[0] == 0)) {
      errorDate = true;
    }
    if (invoiceDate && splitDate.length == 1) {
      errorDate = true;
    }
    if (errorDate) {
      if (name === 'writeOffDate')
        detailTab.errorInvalidWirteOffDate = !!errorDate;
      else if (name === 'writeOffDatePop')
        detailTab.errorInvalidWirteOffDatePop = !!errorDate;
      const data = {
        ...maintainContractState,
        ...detailTab,
      };
      dispatch(maintainContractActions(data));
      return false;
    } else {
      let finalDate;
      if (name === 'writeOffDate') detailTab.errorInvalidWirteOffDate = false;
      else if (name === 'writeOffDatePop')
        detailTab.errorInvalidWirteOffDatePop = false;
      const inDate = event.target.value;
      const sptDate =
        invoiceDate && invoiceDate.includes('_')
          ? invoiceDate.split('_')
          : invoiceDate;
      const invDate =
        sptDate && sptDate.length > 0 && sptDate[0].includes('/')
          ? sptDate[0].split('/')
          : sptDate;
      const dateLength = invDate.length;
      detailTab.errorInvalidWirteOffDate = false;
      if (dateLength == 2 && invDate[1].length == 2) {
        const years2D =
          invDate[1].length == 2 && invDate[1] < 43
            ? `20${invDate[1]}`
            : `19${invDate[1]}`;
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/` + '01' + `/${years2D}`;
        const data = {
          ...maintainContractState,
          detailTab: {
            ...detailTab,
            [name]: finalDate,
          },
        };
        dispatch(maintainContractActions(data));
      } else if (dateLength == 2 && invDate[1].length == 4) {
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/` + '01' + `/${invDate[1]}`;
        const data = {
          ...maintainContractState,
          detailTab: {
            ...detailTab,
            [name]: finalDate,
          },
        };
        dispatch(maintainContractActions(data));
      } else if (dateLength == 3 && invDate[2].length == 2) {
        const years2D =
          invDate[2].length == 2 && invDate[2] < 43
            ? `20${invDate[2]}`
            : `19${invDate[2]}`;
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        finalDate = `${month}/${invDate[1]}/${years2D}`;
        const data = {
          ...maintainContractState,
          detailTab: {
            ...detailTab,
            [name]: finalDate,
          },
        };
        dispatch(maintainContractActions(data));
      } else if (dateLength == 3 && invDate[2].length == 4) {
        const month = invDate[0].length < 2 ? `0${invDate[0]}` : invDate[0];
        const day = invDate[1].length < 2 ? `0${invDate[1]}` : invDate[1];
        finalDate = `${month}/${day}/${invDate[2]}`;
        const data = {
          ...maintainContractState,
          detailTab: {
            ...detailTab,
            [name]: finalDate,
          },
        };
        dispatch(maintainContractActions(data));
      } else {
        const data = {
          ...maintainContractState,
          detailTab: {
            ...detailTab,
            [name]: event.target.value,
          },
        };
        dispatch(maintainContractActions(data));
      }
    }
  };
  // On click on the Ok button of Write off pop up
  const onClickOkWriteOff = () => {
    if (!detailTab.errorInvalidWirteOffDatePop) {
      dispatch(
        getWriteOffDateContract({
          contractSeqNum:
            getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
              .contractSeqNum,
          userId: logInUser,
          date: moment(detailTab.writeOffDatePop).format('MM/DD/YYYY'),
        })
      );
      const data = {
        ...maintainContractState,
        showSaveButton: 'Yes',
      };
      dispatch(maintainContractActions(data));
      setWriteOffDialog(false);
    }
  };
  const [checkBox, setCheckBox] = React.useState({
    rebateProgramDefault: false,
    commercialManufacturer: false,
  });
  const [dialog, setDialog] = React.useState(false);
  // On clicking of the check box of Use Rebate Program Defaults
  const handleChange = () => {
    dispatch(
      getDefaultRpcData({
        mfgId: null,
        rebateProgramCd:
          searchContractState.contractType === 'onSelect'
            ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                ?.rebateProgramCd
            : searchContractState.createRebateProgramCode,
      })
    );
  };
  // On Load of the service call of use default
  React.useEffect(() => {
    if (
      getRpcData &&
      Object.keys(getRpcData).length > 0 &&
      detailTab.useDefRpcInd === true
    ) {
      const detailData = {};
      detailData.useDefRpcInd = detailTab.useDefRpcInd == 1;
      detailData.detailInvoices = getRpcData?.defDetailLevelOnInvoiceCd || '-1';
      detailData.disputeSpecialists = getRpcData?.progDefDispSpecialist || '-1';
      detailData.letterSender = getRpcData?.defLetterSenderUserId || '-1';
      detailData.earliestQuarter =
        getRpcData?.defEarliestQtrForDrugDtls || null;

      const newdata = {
        ...maintainContractState,
        detailTab: {
          ...detailTab,
          ...detailData,
        },
      };
      dispatch(maintainContractActions(newdata));
    }
  }, [getRpcData]);
  React.useEffect(() => {
    if (getWriteOffDate == 'Contract Write off success') {
      const data = {
        ...maintainContractState,
        showSaveButton: 'Yes',
        detailTab: {
          ...detailTab,
          writeOffDate: moment(detailTab.writeOffDatePop).format('MM/DD/YYYY'),
        },
      };
      dispatch(maintainContractActions(data));
      dispatch(dispatchWriteOffDate(''));
    }
    setWriteOffDialog(false);
  }, [getWriteOffDate]);
  React.useEffect(() => {
    if (getUndoWriteOffDate == 'Contract Undo Write off success') {
      const data = {
        ...maintainContractState,
        showSaveButton: 'Yes',
        detailTab: {
          ...detailTab,
          writeOffDate: null,
        },
      };
      dispatch(maintainContractActions(data));
    }
    setUndoWriteOffDialog(false);
  }, [getUndoWriteOffDate]);
  const onCancelClick = () => {
    const detailData = {};
    setSendCommDialog(false);
    detailData.sendToCommercialMfgInd = false;

    const newdata = {
      ...maintainContractState,
      detailTab: {
        ...detailTab,
        ...detailData,
      },
    };
    dispatch(maintainContractActions(newdata));
  };
  const handleUndoWriteAction = () => {
    setUndoWriteOffDialog(true);
    dispatch(dispatchUndoWriteOffDate(''));
  };
  const onClickOkUndoWriteOff = () => {
    dispatch(
      getUndoWriteOffDateContract({
        contractSeqNum:
          getAllContractData.cdetailsHeaderAndCalcAndMfgAndDetailsTab
            .contractSeqNum,
        userId: logInUser,
      })
    );
  };
  return (
    <div className="tBillPanel" data-testid="detail-component">
      <Form>
        <div className="row my-2">
          <Form.Group className="col-6" controlId="formBasicCheckbox">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              id="rebate-checkbox"
              data-testid="rebate_checkbox"
              label="Use Rebate Program Defaults"
              checked={detailTab.useDefRpcInd}
              disabled={!isTabEditable}
              onChange={(e) => {
                if (!isTabEditable) {
                  return;
                }
                if (detailTab.useDefRpcInd === false) {
                  setDialog(true);
                }
                const data = {
                  ...maintainContractState,
                  showSaveButton: 'Yes',
                  detailTab: {
                    ...detailTab,
                    useDefRpcInd: !detailTab.useDefRpcInd,
                  },
                };
                dispatch(maintainContractActions(data));
              }}
            />
          </Form.Group>
          {searchContractState.contractType === 'onSelect' &&
            checkActionAccessByRole(
              process.env.REACT_APP_HIDE_ACCESS_ROLES,
              kcRoles
            ) && (
              <div className="col-6 d-flex justify-content-end">
                <div className="th-icon-group mt-2">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
                  >
                    <Dropdown className="icon-dropdown-container">
                      <Dropdown.Toggle
                        className="icon-dropdown"
                        aria-label="Write Off"
                      >
                        <SVGComponent iconName="Icon-export" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {getAllContractData &&
                          getAllContractData
                            ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                            ?.writeOffDt == null && (
                            <Dropdown.Item
                              role="button"
                              data-testid="writeOffAction"
                              onClick={() => {
                                handleAction();
                              }}
                              disabled={
                                !(
                                  getAllContractData &&
                                  getAllContractData
                                    ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                                    ?.endDt !== null
                                ) || !isEnablebyRole
                              }
                            >
                              Write Off
                            </Dropdown.Item>
                          )}
                        {getAllContractData &&
                          getAllContractData
                            ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                            ?.writeOffDt != null &&
                          getAllContractData
                            ?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                            ?.writeOffDt != '' && (
                            <Dropdown.Item
                              role="button"
                              data-testid="writeOffUndo"
                              onClick={() => {
                                handleUndoWriteAction();
                              }}
                              disabled={isEnablebyRole === false}
                            >
                              Undo Write Off
                            </Dropdown.Item>
                          )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </OverlayTrigger>
                </div>
                <div className="th-icon-group mt-2">
                  <OverlayTrigger
                    placement="bottom"
                    overlay={
                      <Tooltip id="history-tooltip">View History</Tooltip>
                    }
                  >
                    <div
                      className="th-icon ic-history frr-contract-detail-tab-icon"
                      data-testid="view_history"
                      role="button"
                      tabIndex="0"
                      onClick={() => {
                        handleViewHistory();
                      }}
                    >
                      <span className="ic-title"> History </span>
                    </div>
                  </OverlayTrigger>
                </div>
              </div>
            )}
        </div>

        <div className="">
          <fieldset className="custom-fieldset custom-height">
            <legend>Rebate Program Overrides</legend>

            <div className="form-wrapper db">
              <div className="row">
                <div className="col-12 col-sm-6 col-lg-4 col-xl-3">
                  <div className="mui-custom-form with-select input-md">
                    <TextField
                      id="Earliest_quarter"
                      className="mandate-fields"
                      label="Earliest Quarter for Drug Details "
                      inputProps={{ maxLength: 6 }}
                      data-testid="Earliest_quarter"
                      fullWidth
                      placeholder=""
                      InputProps={{ id: 'Earliest_quarter' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={
                        detailTab.useDefRpcInd ||
                        detailTab.sendToCommercialMfgInd ||
                        !isTabEditable
                      }
                      name="earliestQuarter"
                      value={detailTab.earliestQuarter}
                      onChange={(e) =>
                        onChangeDetailsField(e, 'earliestQuarter')
                      }
                      onBlur={(e) => {
                        handleOnBlurEventOnFields(
                          e.target.value,
                          'earliestQuarter'
                        );
                      }}
                      helperText={
                        errorMessagesFromRedux?.length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter((x) => {
                                    return x.fieldName === 'earliestQuarter';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.length > 0 &&
                        errorMessagesFromRedux?.filter((x) => {
                          return x.fieldName === 'earliestQuarter';
                        }).length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter((x) => {
                                    return x.fieldName === 'earliestQuarter';
                                  })
                                  .map((item) => {
                                    return item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4 col-xl-3">
                  <div className="mui-custom-form with-select input-md">
                    <TextField
                      id="Detail_Invoice"
                      className="mandate-fields"
                      label="Detail Level of invoice "
                      data-testid="Detail_Invoice"
                      fullWidth
                      select
                      placeholder=""
                      InputProps={{ id: 'Detail_Invoice' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={
                        detailTab.useDefRpcInd ||
                        detailTab.sendToCommercialMfgInd ||
                        !isTabEditable
                      }
                      name="detailInvoices"
                      value={
                        detailTab.detailInvoices
                          ? detailTab.detailInvoices
                          : '-1'
                      }
                      onChange={(e) =>
                        onChangeDetailsField(e, 'detailInvoices')
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {commonDropdownList?.DETAIL_LEVEL_ON_INVOICE_CD?.map(
                        (res, key) => (
                          <MenuItem
                            value={res?.codeValueID?.codeValue}
                            key={key}
                          >
                            {res.codeValueID?.codeValue} :{' '}
                            {res.shortDescription}
                          </MenuItem>
                        )
                      )}
                    </TextField>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4 col-xl-3">
                  <div className="mui-custom-form with-select input-md">
                    <TextField
                      id="Dispute_Specialists"
                      className="mandate-fields"
                      label="Dispute Specialists "
                      data-testid="Dispute_Specialists"
                      fullWidth
                      select
                      placeholder=""
                      InputProps={{
                        id: 'Dispute_Specialists',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={
                        detailTab.useDefRpcInd ||
                        detailTab.sendToCommercialMfgInd ||
                        !isTabEditable
                      }
                      name="disputeSpecialists"
                      value={
                        detailTab.disputeSpecialists
                          ? detailTab.disputeSpecialists
                          : '-1'
                      }
                      onChange={(e) =>
                        onChangeDetailsField(e, 'disputeSpecialists')
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {getDisputeSpecialists && getDisputeSpecialists.length > 0
                        ? getDisputeSpecialists?.map((res, index) => (
                            <MenuItem
                              value={res?.userId}
                              key={index}
                              className="frr-logcheck-dropdown-item"
                            >
                              {res?.userId} - {res?.lastName} , {res?.firstName}
                            </MenuItem>
                          ))
                        : null}
                    </TextField>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-4 col-xl-3">
                  <div className="mui-custom-form with-select input-md">
                    <TextField
                      id="Letter_Sender"
                      className="mandate-fields"
                      label="Letter Sender "
                      data-testid="Letter_Sender"
                      fullWidth
                      select
                      placeholder=""
                      InputProps={{
                        id: 'Letter_Sender',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={
                        detailTab.useDefRpcInd ||
                        detailTab.sendToCommercialMfgInd ||
                        !isTabEditable
                      }
                      name="letterSender"
                      value={
                        detailTab.letterSender ? detailTab.letterSender : '-1'
                      }
                      onChange={(e) => onChangeDetailsField(e, 'letterSender')}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {getLetterSender && getLetterSender.length > 0
                        ? getLetterSender?.map((res, index) => (
                            <MenuItem
                              value={res?.userId}
                              key={index}
                              className="frr-logcheck-dropdown-item"
                            >
                              {res?.userId} - {res?.lastName} , {res?.firstName}
                            </MenuItem>
                          ))
                        : null}
                    </TextField>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <Form.Group className="my-3" controlId="formBasicCheckbox">
            <FormControlLabel
              control={<Checkbox color="primary" />}
              id="commercial-checkbox"
              data-testid="commercial_checkbox"
              label="Send to Commercial Manufacturer"
              checked={detailTab.sendToCommercialMfgInd}
              disabled={
                !isTabEditable || searchContractState?.planType === 'ST'
              }
              onChange={(e) => {
                if (detailTab.sendToCommercialMfgInd === false) {
                  setSendCommDialog(true);
                }
                const data = {
                  ...maintainContractState,
                  showSaveButton: 'Yes',
                  detailTab: {
                    ...detailTab,
                    sendToCommercialMfgInd: !detailTab.sendToCommercialMfgInd,
                  },
                };
                dispatch(maintainContractActions(data));
              }}
            />
          </Form.Group>
          <div className="row">
            <div className="col-3 pl-2">
              <div className="mui-custom-form input-md">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    data-testid="writeOffDate"
                    className="mandate-fields"
                    id="writeOff"
                    disabled
                    label="Write Off date"
                    format={dateFormatForDatePicker}
                    inputFormat={dateFormatForDatePicker}
                    mask="__/__/____"
                    minDate={MinDate}
                    MaxDate={MaxDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      readOnly: false,
                      autoFill: false,
                      id: 'writeOff',
                    }}
                    placeholder="mm/dd/yyyy"
                    value={detailTab.writeOffDate}
                    onChange={(d) => {
                      onChangeDateField(d, 'writeOffDate');
                    }}
                    onBlur={(e) => {
                      handleOnBlurDateEvent(e, 'writeOffDate');
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'write Off',
                    }}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => x.fieldName === 'writeOffDate')
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter(
                        (x) => x.fieldName === 'writeOffDate'
                      ).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => x.fieldName === 'writeOffDate')
                                .map((item) => {
                                  return item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>
          </div>
        </div>
      </Form>
      <CommonModal
        open={writeOffDialog}
        data-testid="commonModal1"
        viewAction
        viewHeader
        onOk={() => onClickOkWriteOff()}
        okTitle="Ok"
        onClose={() => {
          setWriteOffDialog(false);
          dispatch(
            maintainContractActions({
              ...maintainContractState,
              detailTab: {
                ...detailTab,
                writeOffDatePop: null,
                errorInvalidWirteOffDatePop: false,
              },
            })
          );
        }}
        closeTitle="Cancel"
        modalTitle="Write Off"
        childrenComponent={
          <WriteOffPopUp
            onChangeDateField={onChangeDateField}
            validateDateFormatOnBlur={validateDateFormatOnBlur}
            mfgName={
              searchContractState.contractType == 'onSelect'
                ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                    ?.mfgName
                : searchContractState?.selectedMfgName
            }
            rebateName={
              searchContractState.contractType == 'onSelect'
                ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                    ?.shortDescr
                : searchContractState?.createRebateProgramCode
            }
          />
        }
      />
      <CommonModal
        open={undoWriteOffDialog}
        viewAction
        viewHeader
        onOk={() => onClickOkUndoWriteOff()}
        okTitle="Ok"
        onClose={() => setUndoWriteOffDialog(false)}
        closeTitle="Cancel"
        modalTitle="Undo Write Off"
        childrenComponent={
          <UndoWriteOffPopUp
            mfgName={
              searchContractState.contractType == 'onSelect'
                ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                    ?.mfgName
                : searchContractState?.selectedMfgName
            }
            rebateName={
              searchContractState.contractType == 'onSelect'
                ? getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
                    ?.shortDescr
                : searchContractState?.createRebateProgramCode
            }
            writeOffDate={detailTab.writeOffDate}
          />
        }
      />
      <CommonModal
        open={dialog}
        viewAction
        viewHeader
        className="dialogPanel frr-rightAlignment custom-check dialog-500"
        onOk={() => {
          handleChange();
          setDialog(false);
        }}
        okTitle="Ok"
        onClose={() => {
          setDialog(false);
          setCheckBox(false);
        }}
        closeTitle="Cancel"
        modalTitle=" Rebate program overrides "
        childrenComponent={
          <div>
            <p>
              Any data in the Rebate Program Overrides section will be replaced
              by the Rebate Program defaults. Do you wish to proceed?
            </p>
          </div>
        }
      />
      <CommonModal
        open={sendCommDialog}
        viewAction
        viewHeader
        className="dialogPanel custom-check dialog-600"
        onOk={() => {
          const detailData = {};
          detailData.sendToCommercialMfgInd = true;

          const newdata = {
            ...maintainContractState,
            detailTab: {
              ...detailTab,
              ...detailData,
            },
          };
          dispatch(maintainContractActions(newdata));
          setSendCommDialog(false);
        }}
        okTitle="Ok"
        onClose={onCancelClick}
        closeTitle="Cancel"
        modalTitle="Send to Commercial Manufacturer "
        childrenComponent={
          <div>
            <p>
              Any data send to commercial manufacturer will be replaced by
              rebtae program defaults. Do you wish to proceed?
            </p>
          </div>
        }
      />
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="CONTRACT"
          keyValue={keyValue}
          columnNames="USE_DEF_RPC_IND,EARLIEST_QTR_FOR_DRUG_DETAILS,DETAIL_LEVEL_ON_INVOICE_CD,CONTRACT_DEF_DISP_SPECIALIST,LETTER_SENDER_USER_ID,SEND_TO_COMMERCIAL_MFG_IND,WRITE_OFF_DT"
        />
      )}
    </div>
  );
};
export default Detail;
